import React from 'react';
import {Chip, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography} from "@mui/material";
import moment from "moment";
import PanoramaFishEyeTwoToneIcon from "@mui/icons-material/PanoramaFishEyeTwoTone";
import {amber, green, grey, indigo, red} from "@mui/material/colors";
import {calcPunteggioIsolamento} from "../form/MonitoraggioIsolamentoGrid";
import {calcScore} from "../../../focolai/detail/FocolaioCard";
import {getScoreColor} from "../../detail/QuarantenaCard";

function getFebbreColor(febbre) {
	if (!febbre) {
		return {backgroundColor: grey["500"], color: "#FFF", borderWidth: "2px", borderColor: grey["900"]};
	}
	let febbreFloat = parseFloat(febbre);
	if (febbreFloat <= 37.4) {
		return {backgroundColor: green[500], color: "#FFF"};
	} else if (febbreFloat >= 37.5 && febbreFloat <= 38.4) {
		return {backgroundColor: amber[600]};
	} else {
		return {backgroundColor: red[500], color: "#FFF"}
	}
}

function getSaturazioneColor(saturazione) {
	if (!saturazione) {
		return {backgroundColor: grey["500"], color: "#FFF", borderWidth: "2px", borderColor: grey["900"]};
	}
	let satFloat = parseFloat(saturazione);
	if (satFloat >= 95) {
		return {backgroundColor: green[500], color: "#FFF"};
	} else if (satFloat <= 91 && satFloat >= 94) {
		return {backgroundColor: amber[600]};
	} else {
		return {backgroundColor: red[500], color: "#FFF"}
	}
}

function getPressioneColor(pressione) {
	if (!pressione) {
		return {backgroundColor: grey["500"], color: "#FFF", borderWidth: "2px", borderColor: grey["900"]};
	}
	let pressioneFloat = parseFloat(pressione);
	if (pressioneFloat <= 139) {
		return {backgroundColor: green[500], color: "#FFF"};
	} else if (pressioneFloat >= 140 && pressioneFloat <= 159) {
		return {backgroundColor: amber[600]};
	} else {
		return {backgroundColor: red[500], color: "#FFF"}
	}
}

const MonitoraggiIsolamentoTable = ({monitoraggi}) => {
	return (
		<React.Fragment>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography align={"left"}
							            style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Data</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography align={"left"}
							            style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>SCORE</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Febbre</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Saturazione</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Press. arteriosa max</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Tosse</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Mal di gola</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>D.R. letto</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>D.R. riposo</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>D.R. movimento</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Cefalea</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Dolori muscolari</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Malessere generale</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Inappetenza</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Vertigini</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Diarrea</b>
							</Typography>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{
						monitoraggi.sort(function (a, b) {
								return new Date(b.dataInserimento) - new Date(a.dataInserimento);
							})
							.map((monitoraggio) => {
								return (
									<TableRow key={monitoraggio.id} hover>
										<TableCell>
											<Typography
												variant={"body2"}>{moment(monitoraggio.dataInserimento).format("DD/MM/YY")}</Typography>
											<Typography variant={"body2"} style={{fontSize: 14}}
											            color={"textSecondary"}>{moment(monitoraggio.dataInserimento).format("HH:mm")}</Typography>
										</TableCell>
										<TableCell>
											<Chip style={{
												fontSize: 18,
												color: calcScore([monitoraggio], "Isolamento", monitoraggio.score) === 1 ? "#000" : "#FFF",
												backgroundColor: getScoreColor("Isolamento", [monitoraggio], monitoraggio.score)
												/*color: "#FFF",
												 backgroundColor: calcPunteggioIsolamento(monitoraggio) === 0 ? green[600] :
												 calcPunteggioIsolamento(monitoraggio) === 1 ? amber[600] :
												 calcPunteggioIsolamento(monitoraggio) === 2 ? orange[600] :
												 calcPunteggioIsolamento(monitoraggio) === 3 ? red[600] :
												 purple[500],*/
											}} label={<b>{calcPunteggioIsolamento(monitoraggio)}</b>}/>
										</TableCell>
										<TableCell>
											<Chip variant={"outlined"} style={{
												...getFebbreColor(monitoraggio.febbre),
											}} label={monitoraggio?.febbre}/>
										</TableCell>
										<TableCell>
											<Chip variant={"outlined"} style={{
												...getSaturazioneColor(monitoraggio.saturazioneO2),
											}} label={monitoraggio?.saturazioneO2}/>
										</TableCell>
										<TableCell>
											<Chip variant={"outlined"} style={{
												...getPressioneColor(monitoraggio.pressioneArteriosaMax),
											}} label={monitoraggio?.pressioneArteriosaMax}/>
										</TableCell>
										<TableCell>
											{
												monitoraggio?.tosse15 ?
													<Tooltip title={"Tosse maggiore di 15 colpi"}>
														<PanoramaFishEyeTwoToneIcon style={{color: red[500]}}/>
													</Tooltip> :
													<PanoramaFishEyeTwoToneIcon
														style={
															monitoraggio?.tosse ? {color: indigo["A700"]} : {}
														}/>
											}
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.malDiGola ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.drl ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.drr ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.drm ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.cefalea ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.doloriMuscolari ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.malessereGenerale ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.inappetenza ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.vertigini ? {color: indigo["A700"]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.diarrea ? {color: indigo["A700"]} : {}}/>
										</TableCell>
									</TableRow>
								)
							})
					}
				</TableBody>
			</Table>
		</React.Fragment>
	);
};

export default React.memo(MonitoraggiIsolamentoTable);
